<template>
	<div class="resetBtn">
		<!-- icon="el-icon-refresh-right" -->
		<el-button
		:size='size'
		style="width:100%;padding-left:5px;padding-right: 5px;margin-top:4px;"
		@click="reset"
		type="warning"
		plain
		ref="btn"
		>重置</el-button>
		<input ref="input" style="width:0px;border:0;outline: none;position: absolute;z-index: -1;"/>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				
			}
		},
		props:{
			size:{
				default:'small'
			}
		},
		mounted(){
		},
		methods: {
			reset(){
				this.$nextTick(()=>{
					this.$refs.input.focus();
				})
				this.$emit('reset')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.resetBtn{
		width:60px;
	}
</style>
